import * as React from "react";
import {IBackOfficeTheme} from "../theme";
import {defaultTheme} from "../default/index";

import {fullWhite, fullBlack} from 'material-ui/styles/colors';
import {BuetzerBuebeLogo} from "./components/BuetzerBuebeLogo";
import {BuetzerBuebeShortLogo} from "./components/BuetzerBuebeShortLogo";
import {BuetzerBuebeNonLoggedBG} from "./components/NonLoggedBG/BuetzerBuebeNonLoggedBG";
import {BasicPhone} from "../components/BasicPhone";

const primaryColor = '#30373d';
const accentColor = '#d7af00';
const accent2Color ='#2a4f4b';
const backgroundColor = '#30373d';
const activeBackgroundColor = '#30373d';
const alternateTextColor = fullWhite;
const labelColor = fullWhite;

export const buetzerBuebeTheme: IBackOfficeTheme = {
  ...defaultTheme,
  primaryColor: primaryColor,
  accentColor: accentColor,
  accent2Color: accent2Color,
  backgroundColor: backgroundColor,
  alternateTextColor: alternateTextColor,
  labelColor: labelColor,
  logo: {
    component: BuetzerBuebeLogo,
    style: {
      width: 314,
      height: 59
    }
  },
  nonLogged: {
    bgComponent: BuetzerBuebeNonLoggedBG,
    phoneComponent: React.createElement(BasicPhone),
    phoneScreenUrl: <string>require('./assets/menu.png')
  },
  navBar: {
    logo: BuetzerBuebeShortLogo,
    backgroundColor: fullBlack,
    activeBackgroundColor: activeBackgroundColor,
    color: fullWhite,
    iconColor: accentColor
  }
};



// WEBPACK FOOTER //
// ./src/themes/buetzerBuebeTheme/index.ts